module.exports = __webpack_public_path__ + "img/2.296551a1.png";